export default __webpack_public_path__ + "static/media/mui.9482fda5.png";